/**
 * @flow
 * @author: Chinmaya
 */

import * as React from 'react'

type Props = {}

class HeaderDownArrow extends React.Component<Props> {
  render() {
    const { width, height, fillColor, className } = this.props

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={width}
        height={height}
        viewBox="0 0 10 6"
      >
        <path
          fill={fillColor}
          fillRule="evenodd"
          d="M4.52 3.143a.67.67 0 0 0 .96 0L8.36.203a.67.67 0 0 1 .961 0l.48.49c.265.27.265.71 0 .98L5.96 5.594c-.53.541-1.39.541-1.92 0L.199 1.674a.705.705 0 0 1 0-.981l.48-.49a.67.67 0 0 1 .96 0l2.881 2.94z"
        />
      </svg>
    )
  }
}

HeaderDownArrow.defaultProps = {
  width: 10,
  height: 6,
  fillColor: '#ffffff'
}

export default HeaderDownArrow
